import React from 'react'
import DocumentTitle from 'react-document-title'
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom'
import ym, { YMInitializer } from 'react-yandex-metrika'
import { AmplitudeUserProp } from "~/amplitude-counter"
import CookieModal from "~/components/cookie-modal"
import { getTitle } from '~helpers/get-title'
import Footer from './footer'
import Menu from './menu'
import { IndexPage } from './pages/index'
import PageNotFound from './pages/page-not-found'
import Phoner404 from './pages/phoner-404'

export const routes = [
  { path: '/', component: IndexPage },
  { path: '/404', component: PageNotFound },
  { path: '/404/phoner', component: Phoner404 },
]

declare global {
  interface Window {
    gtag?: (
      key: string,
      trackingId: string,
      config: { page_path: string }
    ) => void
  }
}

export const MainRouter: React.FC = () => {
  const history = useHistory()
  const location = useLocation()

  const [cookiesAgreed, setCookiesAgreed] = React.useState(true)

  const hasCookiesAgreed = (): boolean => {
    const cookiesArray = document.cookie.split(';')
    const cookieAgreement = cookiesArray.find(item => item.includes('accepted_cookie_agreement='))
    if (cookieAgreement) return cookieAgreement.trim().split('=')[1] === 'true'
    return false
  }

  const acceptCookies = () => {
    document.cookie = 'accepted_cookie_agreement=' + 'true' + '; ' + 'Max-Age=31536000' + '; ' + document.cookie
    setCookiesAgreed(true)
  }

  React.useEffect(
    () => {
      history.listen((location) => {
        ym('hit', location.pathname)
        window.gtag('config', 'UA-63883905-2', { page_path: location.pathname })
      })
      setCookiesAgreed(hasCookiesAgreed())
      return () => {}
    },
    []
  )

  React.useEffect(() => {
    return () => {
      window.scrollTo(0, 0)
    }
  }, [location])

  React.useEffect(() => {
    const href = new URL(window.location.href)
    const utmCampaign = href.searchParams.get('utm_campaign') || ''
    const utmContent = href.searchParams.get('utm_content') || ''
    const utmMedium = href.searchParams.get('utm_medium') || ''
    const utmSource = href.searchParams.get('utm_source') || ''
    const utmTerm = href.searchParams.get('utm_term') || ''
    const rawPartnerId = href.searchParams.get('partnerId') || ''
    const hasPartnerId = !!rawPartnerId && !isNaN(+rawPartnerId.charAt(0))
    const partnerId = hasPartnerId ? Number.parseInt(rawPartnerId) + '' : ''
    const promo = href.searchParams.get('promo') || ''
    let preHostname = window.location.hostname.split('.').slice(1).join('.')
    if (preHostname) {
      preHostname = '.' + preHostname
    }
    const hostname = preHostname || window.location.hostname

    AmplitudeUserProp({ 'referral_value': partnerId ? partnerId : false })

    utmCampaign && !document.cookie.includes(`utm_campaign=${utmCampaign};`) && (document.cookie = 'utm_campaign=' + utmCampaign + '; ' + 'Max-Age=100000' + '; ' + document.cookie) && (document.cookie = 'utm_campaign=' + utmCampaign + '; ' + 'Max-Age=100000' + '; ' +  'Domain=' + hostname + '; ' + document.cookie)
    utmContent && !document.cookie.includes(`utm_content=${utmContent};`) && (document.cookie = 'utm_content=' + utmContent + '; ' + 'Max-Age=100000' + '; ' + document.cookie) && (document.cookie = 'utm_content=' + utmContent + '; ' + 'Max-Age=100000' + '; ' + 'Domain=' + hostname + '; ' + document.cookie)
    utmMedium && !document.cookie.includes(`utm_medium=${utmMedium};`) && (document.cookie = 'utm_medium=' + utmMedium + '; ' + 'Max-Age=100000' + '; ' + document.cookie) && (document.cookie = 'utm_medium=' + utmMedium + '; ' + 'Max-Age=100000' + '; ' + 'Domain=' + hostname + '; ' + document.cookie)
    utmSource && !document.cookie.includes(`utm_source=${utmSource};`) && (document.cookie = 'utm_source=' + utmSource + '; ' + 'Max-Age=100000' + '; ' + document.cookie) && (document.cookie = 'utm_source=' + utmSource + '; ' + 'Max-Age=100000' + '; ' + 'Domain=' + hostname + '; ' + document.cookie)
    utmTerm && !document.cookie.includes(`utm_term=${utmTerm};`) && (document.cookie = 'utm_term=' + utmTerm + '; ' + 'Max-Age=100000' + '; ' + document.cookie) && (document.cookie = 'utm_term=' + utmTerm + '; ' + 'Max-Age=100000' + '; ' + 'Domain=' + hostname + '; ' + document.cookie)
    partnerId && !document.cookie.includes(`partnerId=${partnerId};`) && (document.cookie = 'partnerId=' + partnerId + '; ' + 'Max-Age=100000' + '; ' + document.cookie) && (document.cookie = 'partnerId=' + partnerId + '; ' + 'Max-Age=100000' + '; ' + 'Domain=' + hostname + '; ' + document.cookie)
    promo && !document.cookie.includes(`promo=${promo};`) && (document.cookie = 'promo=' + promo + '; ' + 'Max-Age=100000' + '; ' + document.cookie) && (document.cookie = 'promo=' + promo + '; ' + 'Max-Age=100000' + '; ' + 'Domain=' + hostname + '; ' + document.cookie)
  }, [])

  return (
    <DocumentTitle title={getTitle(location.pathname)}>
      <>
        <YMInitializer
          version='2'
          accounts={[631388]}
          options={{
            webvisor: true,
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            trackHash: true
          }}
        />
        {
          location.pathname !== '/new-year' && location.pathname !== '/new-year/' &&
          <Menu />
        }
        <Switch>
          {
            routes.map(route =>
              <Route exact path={route.path} component={route.component} />
            )
          }
          <Redirect to='/404' />
        </Switch>
        {
          location.pathname !== '/new-year' && location.pathname !== '/new-year/' &&
          <Footer />
        }
        {
          !cookiesAgreed && <CookieModal acceptCookies={acceptCookies} />
        }
      </>
    </DocumentTitle>
  )
}


export default MainRouter
